import * as Turbo from "@hotwired/turbo";
import BaseStimulusModelController from "../../../BaseStimulusModelController";
import { CreateNewPoiFromMapStimulusModel } from "../../../../scripts/_generated/CreateNewPoiFromMapStimulusModel";
import { REQUEST_ID_HEADER, scheduleWaitForJobCompletion, showErrorDialog } from "../../../../scripts/jobCompletion";

export default class CreateNewPoiFromMapController extends BaseStimulusModelController<CreateNewPoiFromMapStimulusModel> {
    connect() { 
        scheduleWaitForJobCompletion(this.modelValue.getJobUrl, this.modelValue.commandGuid, () => {            
            const queryDestinationPoiContentUniqueIdUrl = this.modelValue.queryDestinationPoiContentUniqueIdUrl
                .replace("$destinationUniqueId", this.modelValue.destinationUniqueId)
                .replace("$language", this.modelValue.language)
                .replace("$otherPoiContentUniqueId", this.modelValue.poiContentUniqueId);

            fetch(queryDestinationPoiContentUniqueIdUrl)
                .then(async response => {
                    if (response.ok) {
                        const destinationPoiContentUniqueId = await response.text();

                        const poisDetailUrl = this.modelValue.poisDetailUrl
                            .replace("$uniqueId", destinationPoiContentUniqueId)
                            .replace("$language", this.modelValue.language)
                            .replace("$destinationUniqueId", this.modelValue.destinationUniqueId);
                        Turbo.visit(poisDetailUrl);
                    }
                    else {
                        const requestId = response.headers.get(REQUEST_ID_HEADER) || undefined;
                        showErrorDialog("Failed to query destination Place Id.", requestId);
                    }
                });
        });
    }
}
